var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkills01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4751 16.75V20.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.566 7.15002C10.7327 7.30002 10.0509 7.15002 9.74782 6.62502C9.44478 6.10002 9.67206 5.35002 10.2024 4.75002C9.52054 4.07502 8.76295 3.62502 7.85385 3.40002C7.62657 4.15002 7.09626 4.75002 6.49019 4.75002C5.88412 4.75002 5.35381 4.22502 5.12654 3.40002C4.14168 3.70002 3.30833 4.15002 2.70226 4.75002C3.23257 5.35002 3.45985 6.10002 3.15681 6.62502C2.85378 7.15002 2.09619 7.30002 1.3386 7.15002C1.18709 7.60002 1.11133 8.05002 1.11133 8.50002C1.11133 8.95002 1.18709 9.40002 1.26285 9.85002C2.09619 9.70002 2.77802 9.85002 3.08105 10.375C3.38409 10.9 3.15681 11.65 2.6265 12.25C3.30833 12.925 4.06592 13.375 4.97502 13.6C5.2023 12.85 5.73261 12.25 6.33868 12.25C6.94475 12.25 7.47506 12.775 7.70233 13.6C8.61144 13.375 9.44478 12.925 10.0509 12.25C9.52054 11.65 9.29327 10.9 9.5963 10.375C9.89933 9.85002 10.6569 9.70002 11.4145 9.85002C11.566 9.40002 11.566 8.95002 11.566 8.50002C11.566 8.05002 11.6418 7.60002 11.566 7.15002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89929 13.525V19",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7176 16.75H14.7479C15.5813 16.75 16.2631 16.075 16.2631 15.25V12.25H18.5359L16.2631 7.75C16.2631 4 13.2327 1 9.44481 1C7.17205 1 5.12657 2.125 3.91443 3.85",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills01);
export default __webpack_public_path__ + "static/media/skills-01.fab562b42132a61706edbec93dc12f1b.svg";
export { ForwardRef as ReactComponent };